import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { BadgeCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { API } from '@/utils/api';

export const ConfirmBilledButton = ({ wo, onDone, size = 'default' }) => {
  const [open, setOpen] = useState(false);
  const [num, setNum] = useState(wo.invoice_number || '');
  const [busy, setBusy] = useState(false);
  if (wo.billed_confirmed) return <span className="text-xs font-bold text-emerald-700 flex items-center gap-1" data-testid={`billed-label-${wo.id}`}><BadgeCheck className="w-4 h-4" />Facturé{wo.invoice_number ? ` · ${wo.invoice_number}` : ''}</span>;
  const confirm = async () => {
    setBusy(true);
    try { await axios.post(`${API}/work-orders/${wo.id}/confirm-billed`, { invoice_number: num }); toast.success('Fiche marquée facturée'); setOpen(false); onDone?.(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Erreur'); } finally { setBusy(false); }
  };
  return (
    <>
      <Button size={size} className="bg-emerald-600 hover:bg-emerald-700 text-white" onClick={(e) => { e.stopPropagation(); setOpen(true); }} data-testid={`confirm-billed-btn-${wo.id}`}>
        <BadgeCheck className="w-4 h-4 mr-1" />Marquer facturé
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" onClick={e => e.stopPropagation()} data-testid="confirm-billed-dialog">
          <DialogHeader><DialogTitle>Confirmer la facturation</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-600">La facture de {wo.client_name || 'ce client'} est faite ? La fiche quittera la liste « Non facturé ».</p>
          <Input value={num} onChange={e => setNum(e.target.value)} placeholder="N° de facture (facultatif)" data-testid="confirm-billed-number" />
          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={() => setOpen(false)} data-testid="confirm-billed-cancel">Annuler</Button>
            <Button className="bg-emerald-600 hover:bg-emerald-700" onClick={confirm} disabled={busy} data-testid="confirm-billed-submit">Oui, c'est facturé</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
